module.exports = __webpack_public_path__ + "img/1.3679d087.jpg";